import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index";

Vue.use(Vuex);

let app = new Vue();

export default new Vuex.Store({
  state: {
    loginRequired: false,
    u: JSON.parse(localStorage.getItem("u") || "{}"), // current user
    course: JSON.parse(localStorage.getItem("course") || "{}"), //current course
    locations: [],
    studentListOptions: [],
  },
  mutations: {
    logout() {
      app.$sisApi("post", "logout");
      localStorage.removeItem("u");
      this.state.u = {};
      router.push("/");
    },
  },
  actions: {
    getLocations({ commit, rootGetters }) {
      app
        .$sisApi("get", `locations`)
        .then((response) => {
          this.state.locations = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(error.response);
          }
        });
    },

    getStudentList({ commit, rootGetters }) {
      app
        .$sisApi("get", `schedules/t-students`)
        .then((response) => {
          this.state.studentListOptions = response.data.options;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(error.response);
          }
        });
    },
  },
});
